import { GET_BUSINESS_LIST, SET_ALL_COMPANY_APPOINTED_LIST, SET_BUSINESS_ACTIVATION_PLAN } from "../actions/types";
const initialState = {
  businessInfo: [],
  count: 0,
  allAppointedList: [],
  businessActivationPlan: null
};
export default function (state = initialState, action) {
  const { type, payload, count } = action;
  switch (type) {
    case GET_BUSINESS_LIST:
      return {
        ...state,
        businessInfo: payload,
        count: count,
      };

    case SET_ALL_COMPANY_APPOINTED_LIST:
      return {
        ...state,
        allAppointedList: payload
      };

    case SET_BUSINESS_ACTIVATION_PLAN:
      return {
        ...state,
        businessInfo: payload?._id
          ? state.businessInfo.map((item) => item._id === payload._id ? payload : item)
          : state.businessInfo,
        businessActivationPlan: payload
      };

    default:
      return state;
  }
}
